import {ProductionMonitoringState} from './types';

export const initialState: ProductionMonitoringState = {
  selectedSuppliers: {},
};
